

import React, { memo } from 'react';
import { NotificationsProvider, notify } from '../../Notifications';
import FilesComponent from '../components/Files';


function handleError(error) {
  notify({
    content: error.message,
    type: 'error'
  });
}

function Files(props) {
  return (
    <NotificationsProvider>
      <FilesComponent {...props} onFilesError={handleError} />
    </NotificationsProvider>);

}

export default memo(Files);